import React from "react";
import { StatusBadgeVariant } from "../../types";

interface StatusBadgeProps {
  label: string;
  variant?: StatusBadgeVariant;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  label,
  variant = "paid",
}) => {
  return (
    <span className={`partner-dashboard-badge partner-dashboard-badge--${variant}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
